import type { Directive, DirectiveBinding } from 'vue'

function applyPinkStyles(el: HTMLElement) {
    el.style.color = 'var(--color-pink)'
    el.style.borderColor = 'var(--color-pink)'

    const originalBg = el.style.backgroundColor

    const onMouseEnter = () => {
        el.style.backgroundColor = 'rgba(203, 159, 165, 0.1)'
    }
    const onMouseLeave = () => {
        el.style.backgroundColor = originalBg
    }
    const onFocus = () => {
        el.style.boxShadow = '0 0 0 2px #ffffff, 0 0 0 4px var(--color-pink), 0 1px 2px 0 black'
    }
    const onBlur = () => {
        el.style.boxShadow = ''
    }

    el.addEventListener('mouseenter', onMouseEnter)
    el.addEventListener('mouseleave', onMouseLeave)
    el.addEventListener('focus', onFocus)
    el.addEventListener('blur', onBlur)
}

export const vPinkElement: Directive = {
    mounted(el: HTMLElement, binding: DirectiveBinding) {
        if (binding.value === false) return
        applyPinkStyles(el)
    },
}
